'use es6';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import UIComponentsCode from 'UIComponents/elements/Code';
import { GREAT_WHITE, GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScopeCode = styled(UIComponentsCode).withConfig({
  displayName: "ScopesList__ScopeCode",
  componentId: "sc-64ysuo-0"
})(["padding:4px;border:1px solid ", ";background-color:", ";"], GREAT_WHITE, GYPSUM);
const ScopesList = ({
  scopes
}) => scopes.map(scope => /*#__PURE__*/_jsx(ScopeCode, {
  children: scope
}, scope));
ScopesList.propTypes = {
  scopes: PropTypes.arrayOf(PropTypes.string)
};
export default ScopesList;